import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { FirebaseContext, useAuth } from '@components/Firebase';

import { Global, css } from '@emotion/core';
import { globalStyles, Spacer, Container } from '@styles';
import { ToastContainer } from 'react-toastify';
import Navbar from '@common/Navbar';
import Sidebar from '@common/Sidebar';
import Footer from '@common/Footer';

import Head from './Head';

export default ({ children }) => {
  const { user, firebase, loading } = useAuth();
  return (
    <StaticQuery
      query={graphql`
        query LayoutQuery {
          site {
            siteMetadata {
              title
              description
              siteUrl
            }
          }
        }
      `}
      render={({ site }) => (
        <FirebaseContext.Provider value={{ user, firebase, loading }}>
          <Head metadata={site.siteMetadata} />
          <Global styles={globalStyles} />

          <Sidebar />
          <Navbar />
          <ToastContainer
            newestOnTop
            css={css`
              width: 400px;
              @media (max-width: 480px) {
                width: 100%;
              }
              .Toastify__toast-body {
                padding: 10px;
              }
            `}
          />
          <div id="content">{children}</div>
          <Container normal>
            <Spacer break2 />
            <Spacer line />
          </Container>
          <Footer />
        </FirebaseContext.Provider>
      )}
    />
  );
};
